import { DirectUpload } from 'activestorage';
import { mapGetters, mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { useAccount } from 'dashboard/composables/useAccount';

export default {
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
  },
  data() {
    return {
      currentAccountId: null,
    };
  },
  async created() {
    const { accountId } = await useAccount();
    this.currentAccountId = accountId;
  },
  methods: {
    ...mapActions('records', ['create']),
    async uploadFile(file, knowledgebaseId) {
      const upload = new DirectUpload(
        file,
        `/api/v1/accounts/${this.currentAccountId}/knowledgebases/${knowledgebaseId}/direct_uploads`,
        {
          directUploadWillCreateBlobWithXHR: xhr => {
            xhr.setRequestHeader(
              'api_access_token',
              this.currentUser.access_token
            );
          },
        }
      );

      return new Promise((resolve, reject) => {
        upload.create((error, blob) => {
          if (error) {
            useAlert(error);
            reject(error);
          } else {
            resolve(blob);
          }
        });
      });
    },
    async attachFile({ file, upload, knowledgebaseId }) {
      try {
        await this.create({
          record: { file: upload.signed_id, status: 'pending' },
          knowledgebaseId,
        });
        useAlert(this.$t('LIBRARIES.FILE.API.SUCCESS_MESSAGE'));
        this.$emit('file-uploaded');
      } catch (error) {
        const errorMessage =
          error?.response?.message ||
          this.$t('LIBRARIES.FILE.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
